import React from "react";
// import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import { Grid } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

import { convertIntToCurrency } from "src/common";

import {
  DivProduct,
  DivProductHeader,
  GridHeader,
  HeaderLabel,
  ImageEmpty,
  ImgProduct,
  PriceLabel,
  ProductName,
  ProductSubDetail,
  WrapperDesc,
  WrapperPriceField,
  WrapperProduct,
  WrapperProductDetail,
  WrapperProductImage,
  WrapperProductList,
} from "src/components/order/components";
import { useAuth } from "src/hooks/useAuth";

/**
 *
 * @param {Array} productOrders - productChoiceOrders
 * @returns
 */
const ProductOrderTable = ({ productOrders = [] }) => {
  const { checkAllowPermission } = useAuth();
  // const adminList = [
  //   "ast.md@xsurface.com",
  //   "bd@xsurface.com",
  //   "service@xsurface.com",
  //   "accountadmin@xsurface.com",
  //   "webdev@xsurface.com",
  // ];

  return (
    <>
      <WrapperProductList>
        <DivProductHeader container>
          <GridHeader
            item
            {...(checkAllowPermission("products.can_view_costPrice")
              ? { lg: 5, md: 5, xs: 4 }
              : { lg: 6.3, md: 6.2, xs: 5.5 })}
            // lg={adminList.includes(user?.email) ? 5 : 6.3}
            // md={adminList.includes(user?.email) ? 5 : 6.2}
            // xs={adminList.includes(user?.email) ? 4 : 5.5}
            // lg={5} md={5} xs={4}
          >
            <HeaderLabel style={{ textAlign: "left" }}>
              {getLocale() === "th" ? "สินค้า" : "Product"}
            </HeaderLabel>
          </GridHeader>

          {checkAllowPermission("products.can_view_costPrice") && (
            <GridHeader item lg={1.3} md={1.2} xs={1.5}>
              <HeaderLabel>
                {getLocale() === "th" ? "ราคาต้นทุน" : "Cost Price"}
              </HeaderLabel>
            </GridHeader>
          )}

          <GridHeader item lg={1.6} md={1.8} xs={2}>
            <HeaderLabel>
              {getLocale() === "th" ? "ราคาขายต่อหน่วย" : "Price per Unit"}
            </HeaderLabel>
          </GridHeader>

          <GridHeader item lg={1.3} md={1.2} xs={1.3}>
            <HeaderLabel>
              {getLocale() === "th" ? "จำนวน" : "Quantity"}
            </HeaderLabel>
          </GridHeader>

          <GridHeader item lg={1.4} md={1.4} xs={1.6}>
            <HeaderLabel>
              {getLocale() === "th" ? "ส่วนลด" : "Discount"}
            </HeaderLabel>
          </GridHeader>

          <GridHeader item lg={1.4} md={1.4} xs={1.6}>
            <HeaderLabel>
              {getLocale() === "th" ? "ราคารวม" : "Total Price"}
            </HeaderLabel>
          </GridHeader>
        </DivProductHeader>

        <DivProduct>
          {productOrders?.map((product, index) => {
            return (
              <WrapperProduct key={`order-product-${index}`}>
                <Grid
                  item
                  {...(checkAllowPermission("products.can_view_costPrice")
                    ? { lg: 5, md: 5, xs: 4 }
                    : { lg: 6.4, md: 6.3, xs: 5.6 })}
                  // lg={adminList.includes(user?.email) ? 5 : 6.4}
                  // md={adminList.includes(user?.email) ? 4.9 : 6.3}
                  // xs={adminList.includes(user?.email) ? 4 : 5.6}
                  // lg={5} md={4.9} xs={4}
                >
                  <WrapperProductDetail>
                    <WrapperProductImage>
                      {!!product?.groupImage?.productDisplayImage ? (
                        <ImgProduct
                          src={product?.groupImage?.productDisplayImage.replace(
                            ".com",
                            ".com/300x300",
                          )}
                          alt={product?.groupImage?.productDisplayImage}
                        />
                      ) : (
                        <ImageEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              cursor: "pointer",
                            }}
                          />
                        </ImageEmpty>
                      )}
                    </WrapperProductImage>

                    <WrapperDesc>
                      <ProductName>
                        {product?.productChoiceOrder?.product?.item_name}
                      </ProductName>

                      <ProductSubDetail>
                        {product?.productChoiceOrder?.product?.item_code}
                      </ProductSubDetail>

                      <ProductSubDetail>
                        {getLocale() === "th"
                          ? product?.color?.colorTh || "-"
                          : product?.color?.colorEn || "-"}
                      </ProductSubDetail>
                    </WrapperDesc>
                  </WrapperProductDetail>
                </Grid>

                {checkAllowPermission("products.can_view_costPrice") && (
                  <Grid
                    item
                    lg={1.4}
                    md={1.4}
                    xs={1.6}
                    sx={{ display: "flex" }}
                  >
                    <WrapperPriceField>
                      <PriceLabel>
                        {convertIntToCurrency(
                          product?.costPrice || product?.price,
                        )}
                      </PriceLabel>
                    </WrapperPriceField>
                  </Grid>
                )}

                <Grid item lg={1.4} md={1.6} xs={1.7} sx={{ display: "flex" }}>
                  <WrapperPriceField>
                    <PriceLabel>
                      {convertIntToCurrency(product?.price)}
                    </PriceLabel>
                  </WrapperPriceField>
                </Grid>

                <Grid item lg={1.4} md={1.3} xs={1.5} sx={{ display: "flex" }}>
                  <WrapperPriceField>
                    <PriceLabel>
                      {product?.volume ? product?.volume : 0}
                    </PriceLabel>
                  </WrapperPriceField>
                </Grid>

                <Grid item lg={1.4} md={1.4} xs={1.6} sx={{ display: "flex" }}>
                  <WrapperPriceField>
                    <PriceLabel>
                      {product?.discount ? product?.discount : "-"}
                    </PriceLabel>
                  </WrapperPriceField>
                </Grid>

                <Grid item lg={1.4} md={1.4} xs={1.6} sx={{ display: "flex" }}>
                  <WrapperPriceField>
                    <PriceLabel>
                      {convertIntToCurrency(product?.total)}
                    </PriceLabel>
                  </WrapperPriceField>
                </Grid>
              </WrapperProduct>
            );
          })}
        </DivProduct>
      </WrapperProductList>
    </>
  );
};

export default ProductOrderTable;
